import logo from "../images/footer_logo.png";
import { FaLinkedinIn, FaFacebookF, FaTwitter } from "react-icons/fa";
import { BsInstagram } from "react-icons/bs";
import { MdCall } from "react-icons/md";
import { HiOutlineMail } from "react-icons/hi";
import { GoLocation } from "react-icons/go";
import Aos from "aos";
import { useEffect } from "react";
import "aos/dist/aos.css";
const Footer = () => {

    useEffect(() => {
        Aos.init({ duration: 1500 });
      }, []);
  return (
    <>
      <div data-aos='fade-up' className="bg-[#1F1D28] flex items-center w-full min-h-[400px] mt-10 sm:px-16 px-8 py-10 relative">
        <div className="flex  md:items-center items-start justify-between w-full h-full md:flex-row flex-col">
          <div>
            <img className="sm:max-w-[140px] max-w-[120px] mb-3" src={logo} alt="" />
            <div className="flex items-center">
              <FaFacebookF className="text-3xl p-1 border border-gray-400 cursor-pointer hover:border-orange-500 hover:text-blue-500 text-gray-200 rounded-lg mr-3" />
              <FaTwitter className="text-3xl p-1 border border-gray-400  cursor-pointer hover:border-orange-500 hover:text-blue-500 text-gray-200 rounded-lg mr-3" />
              <BsInstagram className="text-3xl p-1 border border-gray-400  cursor-pointer hover:border-orange-500 hover:text-blue-500 text-gray-200 rounded-lg mr-3" />
              <FaLinkedinIn className="text-3xl p-1 border border-gray-400 cursor-pointer hover:border-orange-500 hover:text-blue-500 text-gray-200 rounded-lg mr-3" />
            </div>
            <div className="mt-8">
              <h2 className="text-gray-400 font-semibold sm:text-xl text-lg">
                For Support
              </h2>
              <h1 className="text-gray-300 font-bold sm:text-3xl text-xl mt-1">
                +91-1234567890
              </h1>
            </div>
          </div>
          <div className="md:my-0 my-2">
            <h1 className="text-slate-200 font-bold sm:text-3xl text-xl sm:mt-0 mt-2">Pages</h1>
            <ul className="sm:mt-4 mt-1">
              <li className="text-gray-300 sm:list-disc hover:text-[#FE4904] cursor-pointer sm:text-lg mb-1">
                About
              </li>
              <li className="text-gray-300 sm:list-disc hover:text-[#FE4904] cursor-pointer sm:text-lg my-1">
                Services
              </li>
              <li className="text-gray-300 sm:list-disc hover:text-[#FE4904] cursor-pointer sm:text-lg my-1">
                Contact
              </li>
              <li className="text-gray-300 sm:list-disc hover:text-[#FE4904] cursor-pointer sm:text-lg my-1">
                Work
              </li>
            </ul>
          </div>
          <div>
          <h1 className="text-slate-200 font-bold sm:text-3xl text-xl sm:mt-0 mt-1">About</h1>
            <div className="sm:mt-4">
              <div className="flex items-center text-gray-300 sm:text-lg sm:my-2 my-1 hover:text-[#FE4904]">
                <MdCall />
                <h1 className="ml-2">+91-1234567890</h1>
              </div>
              <div className="flex items-center text-gray-300 sm:text-lg sm:my-2 my-1 hover:text-[#FE4904]">
                <HiOutlineMail />
                <h1 className="ml-2">email@example.com</h1>
              </div>
              <div className="flex items-center text-gray-300 sm:text-lg sm:my-2 my-1 hover:text-[#FE4904]">
                <GoLocation />
                <h1 className="ml-2">
                  Mitra Road,Bhayender,Mumbai Maharashtra
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-[#24222E] h-[50px] flex items-center">
        <h2 className="text-slate-300 w-full text-center">© 2023 xilio. All Rights Reserved</h2>
      </div>
    </>
  );
};
export default Footer;
